export default __webpack_public_path__ + "static/kz-c6dde068eaf34baa8e0da6f49e7e813b.svg";